import { all } from 'redux-saga/effects';
import clientSaga from '../client/client-saga';
import scopeSaga from '../scopes/scope-saga';
import logoutSaga from '../authorization/logout-saga';

// watcher saga: watches for actions dispatched to the store, starts worker saga

export function* rootSaga() {
	yield all([clientSaga(), scopeSaga(), logoutSaga()]);
}
